export enum IUrlUpenMethod {
  OrigamTab = "OrigamTab"
}